var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:Object.assign({}, _vm.styleSize, _vm.styleDisabled),attrs:{"type":"submit"},on:{"click":function($event){return _vm.exec()}}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }